import { render, staticRenderFns } from "./AslProjects.vue?vue&type=template&id=5dca4c0c&scoped=true"
import script from "./AslProjects.vue?vue&type=script&lang=js"
export * from "./AslProjects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dca4c0c",
  null
  
)

export default component.exports